/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelDictionaryRequest,
  ModelDictionaryResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Dictionary<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get predefined dictionary
   *
   * @tags table catalog
   * @name DictionaryCreate
   * @summary get predefined dictionary
   * @request POST:/dictionary
   */
  dictionaryCreate = (
    request: ModelDictionaryRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelDictionaryResponse, any>({
      path: `/dictionary`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
